import React from 'react';
import { motion } from 'framer-motion';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const ReservationHero = () => {
  return (
    <section className="relative h-[500px] overflow-hidden">
      <Image
        src="https://images.unsplash.com/photo-1517248135467-4c7edcad34c4"
        alt="Elegant restaurant interior with beautifully set tables and warm ambient lighting"
        className="w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/50 to-transparent"></div>
      <div className="absolute inset-0 flex items-center justify-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center px-4"
        >
          <div className="inline-flex items-center space-x-2 bg-accent px-4 py-2 rounded-full mb-6">
            <Icon name="Calendar" size={20} className="text-accent-foreground" />
            <span className="text-accent-foreground font-body font-bold">RESERVATIONS</span>
          </div>
          
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-heading font-bold text-white mb-6">
            Reserve Your <span className="text-primary">Table</span>
          </h1>
          
          <p className="text-xl text-white/90 font-body max-w-2xl mx-auto">
            Experience exceptional dining at Kahlovera. Book your table and let us create an unforgettable meal for you.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default ReservationHero;